module.exports = __webpack_public_path__ + "static/media/bg2.88fb700f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/NewTimeline/assets/bg2.svg
// module id = 269
// module chunks = 0